
const imgDir = '../../../../assets/it/img';
const topNavDir = '/top-nav';
const sideNavDir = '/side-nav';

export const LOAD_SVG_RESOURCES = {
  topBarLeftArrowIcon : `${imgDir}` + `${topNavDir}` + '/left-arrow.svg',

  fundDayEndReportWhiteIcon : `${imgDir}` + `${sideNavDir}` + '/fde-report-white.svg',
  fundDayEndReportBlackIcon : `${imgDir}` + `${sideNavDir}` + '/fde-report-black.svg',
  newSecurityWhiteIcon : `${imgDir}` + `${sideNavDir}` + '/new-security-white.svg',
  newSecurityBlackIcon : `${imgDir}` + `${sideNavDir}` + '/new-security-black.svg'
}
